import * as React from 'react'

import { BasketContext } from '@thg-commerce/enterprise-core'
import { spacing } from '@thg-commerce/enterprise-theme'
import { ButtonEmphases } from '@thg-commerce/gravity-elements'

import { ClickAndCollectButton, StyledInfoIcon } from './styles'

export interface ClickAndCollectButtonRendererProps {
  text: string
  disabled: boolean
  isFullWidth?: boolean
  emphasis: ButtonEmphases
  dataTestId: string
  showIcon?: boolean
  presentClickAndCollectModalProps: {
    sku: string
    image: string
    title: string
    isProductPage: boolean
    quantity: number
    externalIdentifier?: string
  }
}

export const ClickAndCollectButtonRenderer = (
  props: ClickAndCollectButtonRendererProps,
) => {
  const { presentClickAndCollectModal } = React.useContext(BasketContext)
  return (
    <div style={{ marginBottom: `${spacing(2)}` }}>
      <ClickAndCollectButton
        data-testid={props.dataTestId}
        sizing="regular"
        emphasis={props.emphasis}
        disabled={props.disabled}
        onClick={() =>
          presentClickAndCollectModal?.current(
            props.presentClickAndCollectModalProps.sku,
            props.presentClickAndCollectModalProps.image,
            props.presentClickAndCollectModalProps.title,
            props.presentClickAndCollectModalProps.isProductPage,
            props.presentClickAndCollectModalProps.quantity,
            undefined,
            props.presentClickAndCollectModalProps.externalIdentifier,
          )
        }
        isFullWidth={props.isFullWidth}
      >
        {props.showIcon && <StyledInfoIcon />}
        {props.text}
      </ClickAndCollectButton>
    </div>
  )
}
